export const enabledCategories = {
  multiselect: [
    "VehicleType",
    "Make",
    "Transmission",
    "FuelType",
    "HybridType",
    "ModelGroup",
    "SaleChannel",
    "SaleLocation",
    "SaleDate",
    "MechanicalReportType",
    "Model",
    "BodyType",
    "LogbookStatus",
    "HasBatteryHealthReport",
    "Grade",
    "Plate",
    "Derivative",
    "VATType",
    "EngineCapacity",
    "ColourGeneric",
    "NumberOfDoors",
    "SaleType",
    "HybridType",
  ],
  range: ["Mileage", "CapCleanPrice", "DateRegistered"],
};

export const onlyShowOptions = {
  LogbookStatus: ["Yes"],
};

export const categoriesWithSearchInput = [
  {
    name: "Make",
    text: "Type to filter Makes",
  },
  {
    name: "ModelGroup",
    text: "Type to filter Model Groups",
  },
  {
    name: "SaleLocation",
    text: "Type to filter Auction Centres",
  },
  {
    name: "Model",
    text: "Type to filter Models",
  },
  {
    name: "Derivative",
    text: "Type to filter Derivatives",
  },
  {
    name: "BodyType",
    text: "Type to filter Body Types",
  },
  {
    name: "Plate",
    text: "Type to filter Plates",
  },
  {
    name: "EngineCapacity",
    text: "Type to filter Engine Capacities",
  },
  {
    name: "SaleType",
    text: "Type to filter Vendors / Sales",
  },
];

export const showMoreOptions = {
  SaleDate: {
    label: "Sale Dates",
    visibleOptionsCount: 7,
  },
  ModelGroupSubfilters: {
    label: "Model Groups",
    visibleOptionsCount: 5,
  },
  DerivativeSubfilters: {
    label: "Derivatives",
    visibleOptionsCount: 5,
  },
  ModelSubfilters: {
    label: "Models",
    visibleOptionsCount: 5,
  },
};

export const filterDisclaimers = [
  {
    filterKey: "Unknown",
    disclaimerText:
      "‘Unknown’ information will become available as vehicles go through further inspection.",
    categoryKey: "Grade",
  },
  {
    filterKey: "Mileage Known",
    disclaimerText:
      "‘Unknown’ information will become available as vehicles go through further inspection.",
    categoryKey: "Mileage",
  },
  {
    filterKey: "Awaiting Appraisal",
    disclaimerText:
      "‘Unknown’ information will become available as vehicles go through further inspection.",
    categoryKey: "awaitingAppraisal",
  },
];

// values taken from AV Search by selecting max value from dropdown
export const filterConstants = {
  maxMileageLimit: "9000000",
  maxCAPCleanLimit: "9000000",
  maxVehicleAgeLimit: "99YEAR",
};

export const FEATURE_FLAG_KEYS = {
  PHEV: "phev",
};
